module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.phone) ? _c('a', {
    staticClass: "place",
    attrs: {
      "href": ("tel:" + _vm.phone)
    }
  }, [_vm._t("default")], 2) : _vm._e(), (_vm.mail) ? _c('a', {
    staticClass: "place",
    attrs: {
      "href": ("mailto:" + _vm.mail)
    }
  }, [_vm._t("default")], 2) : _vm._e(), (_vm.site) ? _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.site
    }
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc263746","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/sidebar/components/LinkElement.vue
// module id = 6f3643111065c44b5e19
// module chunks = 0